import {
  clsx_default
} from "../../../chunk-QJVDQ4DQ.mjs";
import {
  Close,
  Content,
  Overlay,
  Portal,
  Root,
  Title
} from "../../../chunk-VXS6VZEN.mjs";
import "../../../chunk-YNII5Y6F.mjs";
import "../../../chunk-RRWBFD4V.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-4U6MH43A.mjs";
import "../../../chunk-OPCIACWD.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-7TMHQ6XO.mjs";
import "../../../chunk-BQ72SK4G.mjs";
import "../../../chunk-FBWCVJGC.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/ChatImageView/ChatImageLightbox.tsx
import * as React from "react";
import { MdClose } from "react-icons/md";
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { Button } from "../Button/Button.mjs";
import { useSwipeToDismiss } from "./lightboxSwipe.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ChatImageLightbox({
  open,
  onOpenChange,
  url,
  alt,
  className,
  container,
  ref
}) {
  const { t } = useComponentsTranslation();
  const panelRef = React.useRef(null);
  const scrimRef = React.useRef(null);
  const attachPanel = React.useCallback((node) => {
    panelRef.current = node;
    if (ref) ref.current = node;
  }, [ref]);
  const swipe = useSwipeToDismiss(() => panelRef.current, () => scrimRef.current, () => onOpenChange(false));
  return /* @__PURE__ */ jsx(Root, { open, onOpenChange, children: /* @__PURE__ */ jsxs(Portal, { container, children: [
    /* @__PURE__ */ jsx(Overlay, { ref: scrimRef, className: "buyscout-chat-lightbox-overlay" }),
    /* @__PURE__ */ jsxs(Content, { ref: attachPanel, className: clsx_default("buyscout-chat-lightbox", className), "aria-describedby": void 0, children: [
      /* @__PURE__ */ jsx(Title, { className: "buyscout-chat-lightbox-title", children: alt ?? t("chatImage.previewTitle") }),
      /* @__PURE__ */ jsx("img", { className: "buyscout-chat-lightbox-img", src: url, alt: alt ?? "", ...swipe }),
      /* @__PURE__ */ jsx(Close, { asChild: true, children: /* @__PURE__ */ jsx(Button, { variant: "glass", color: "neutral", shape: "circle", size: "md", iconOnly: true, "aria-label": t("chatImage.closeAria"), className: "buyscout-chat-lightbox-close", children: /* @__PURE__ */ jsx(MdClose, { "aria-hidden": true }) }) })
    ] })
  ] }) });
}
ChatImageLightbox.displayName = "ChatImageLightbox";
export {
  ChatImageLightbox
};
//# sourceMappingURL=ChatImageLightbox.mjs.map